import React, { useMemo, useState } from 'react'

import { COLORS } from '../../styles'

import Styled from './RecipeAuthorBadge.styled'

const RecipeAuthorBadge = ({ className, name, imageUrl }) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const [imageBroken, setImageBroken] = useState(false)

  const fallbackImageUrl = useMemo(() => {
    const firstLetter = name.charAt(0).toUpperCase()
    const lettrines = new RegExp('[A-Z]')
    return lettrines.test(firstLetter)
      ? `${process.env.NEXT_PUBLIC_USER_ASSETS_URL}/letters/letter_${firstLetter}.png`
      : ''
  }, [name])

  return (
    <Styled className={className}>
      <Styled.information>
        <Styled.imageContainer imageLoaded={imageLoaded}>
          {(imageUrl || fallbackImageUrl) && !imageBroken ? (
            <Styled.image
              src={imageUrl || fallbackImageUrl}
              title={name}
              alt={name}
              loading="lazy"
              onLoad={() => setImageLoaded(true)}
              onError={() => setImageBroken(true)}
            />
          ) : (
            <Styled.imageBroken>
              <Styled.icon
                name="profile-fill-login-16"
                width={16}
                height={16}
                fill={COLORS.yolk}
              />
            </Styled.imageBroken>
          )}
        </Styled.imageContainer>
        <Styled.name>{name}</Styled.name>
      </Styled.information>
    </Styled>
  )
}

export default RecipeAuthorBadge
